import { createReducer } from 'redux-act';
import actions from '../actions/candidateActions';

const initialState = {
  createCandidatePending: false,
  createCandidateRes: null,
  createCandidateError: null,

  updateCandidateDetailsPending: false,
  updateCandidateDetailsRes: null,
  updateCandidateDetailsError: null,

  getAllCandidatePending: false,
  getAllCandidateRes: null,
  getAllCandidateError: null,

    saveCandidateData: null,

};
/* Add Candidate Reducers*/
const handleCreateCandidateRequest = state => {
  return {
    ...state,
    ...{
      createCandidatePending: true,
      createCandidateRes: null,
      createCandidateError: null,
    },
  };
};
const handleCreateCandidateSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      createCandidatePending: false,
      createCandidateRes: payload,
      createCandidateError: null,
    },
  };
};
const handleCreateCandidateError = (state, payload) => ({
  ...state,
  ...{
    createCandidatePending: false,
    createCandidateRes: null,
    createCandidateError: payload,
  },
});


/* Add Candidate Reducers*/
const handleUpdateCandidateDetailsRequest = state => {
  return {
    ...state,
    ...{
      updateCandidateDetailsPending: true,
      updateCandidateDetailsRes: null,
      updateCandidateDetailsError: null,
    },
  };
};
const handleUpdateCandidateDetailsSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      updateCandidateDetailsPending: false,
      updateCandidateDetailsRes: payload,
      updateCandidateDetailsError: null,
    },
  };
};
const handleUpdateCandidateDetailsError = (state, payload) => ({
  ...state,
  ...{
    updateCandidateDetailsPending: false,
    updateCandidateDetailsRes: null,
    updateCandidateDetailsError: payload,
  },
});



/* Get All Candidate Reducers */
const handleGetAllCandidateRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllCandidatePending: true,
      getAllCandidateRes: null,
      getAllCandidateError: null,
    },
  };
};
const handleGetAllCandidateSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllCandidatePending: false,
      getAllCandidateRes: payload,
      getAllCandidateError: null,
    },
  };
};
const handleGetAllCandidateError = (state1, payload) => ({
  ...state1,
  ...{
    getAllCandidatePending: false,
    getAllCandidateRes: null,
    getAllCandidateError: payload,
  },
});

const handleSaveCandidateDataRequest = (state1, payload) => ({
  ...state1,
  ...{

    saveCandidateData: payload,
  },
});


/* Clear Candidate Store */
const clearCandidateStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_CREATE_CANDIDATE_STORE':
      return {
        ...state,
        ...{
          createCandidatePending: false,
          createCandidateRes: null,
          createCandidateError: null,
        },
      };
    case 'HANDLE_CLEAR_GET_UPDATE_CANDIDATE_DETAILS_STORE':
      return {
        ...state,
        ...{
          updateCandidateDetailsPending: false,
          updateCandidateDetailsRes: null,
          updateCandidateDetailsError: null,
        },
      };
       case 'HANDLE_CLEAR_GET_SAVE_CANDIDATE_DATA_STORE':
      return {
        ...state,
        ...{
          saveCandidateData: null,
         
        },
      };
  }
};



export default createReducer(
  {
    [actions.createCandidateRequest]: handleCreateCandidateRequest,
    [actions.createCandidateSuccess]: handleCreateCandidateSuccess,
    [actions.createCandidateError]: handleCreateCandidateError,

    [actions.updateCandidateDetailsRequest]: handleUpdateCandidateDetailsRequest,
    [actions.updateCandidateDetailsSuccess]: handleUpdateCandidateDetailsSuccess,
    [actions.updateCandidateDetailsError]: handleUpdateCandidateDetailsError,

    [actions.getAllCandidateRequest]: handleGetAllCandidateRequest,
    [actions.getAllCandidateSuccess]: handleGetAllCandidateSuccess,
    [actions.getAllCandidateError]: handleGetAllCandidateError,

    [actions.saveCandidateDataRequest]: handleSaveCandidateDataRequest,

    [actions.handleClearCandidateStore]: clearCandidateStore,
  },
  initialState,
);